@if (socketId() && linkUrl()) {
  <vl-qr-code [data]="linkUrl()"></vl-qr-code>
} @else {
  <p>{{ 'qr_link.creating' | trans }}</p>
}
